"use strict";

/**
 * @file
 * JS for the Cappuccino base theme.
 */
(function ($, Drupal) {
  function formatNumber(num) {
    var dec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return num.toFixed(dec).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'");
  }
  function findDecimal(num) {
    var decimal = parseFloat(num).toFixed(2).toString().split('.')[1];
    if (decimal === '00') {
      return 0;
    }
    if (decimal.charAt(1) === '0') {
      return 1;
    }
    return 2;
  }
  function animateKeymCounter($keym) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var $keymCounter = $keym.find('.ino-pt-keym-amount');
    var dec = findDecimal($keymCounter.text());
    $keymCounter.prop('counter', 0).animate({
      counter: $keymCounter.text()
    }, {
      duration: duration,
      step: function step(_step) {
        $keymCounter.text('' + formatNumber(_step, dec));
      }
    });
  }
  function animateKeymProgressRing($keym) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var $circle = $keym.find('.ino-pt-keym-progress-ring-circle');
    var circle = $circle.get(0);
    var radius = circle.r.baseVal.value;
    var circumference = radius * 2 * Math.PI;
    circle.style.strokeDasharray = "".concat(circumference, " ").concat(circumference);
    circle.style.strokeDashoffset = "".concat(circumference);
    var offset = circumference - $circle.data('percent') / 100 * circumference;
    circle.style.strokeDashoffset = offset;
  }
  function animateKeymOpacity($keym) {
    $keym.css({
      opacity: '1'
    });
  }
  function animateKeymFlipElement($keym) {
    $keym.css({
      transform: 'rotateY(0)'
    });
  }
  function animateKeym($keym) {
    if ($keym.hasClass('layout--ino-pt-keym-basic')) {
      animateKeymOpacity($keym);
      animateKeymCounter($keym);
    } else if ($keym.hasClass('layout--ino-pt-keym-flip')) {
      animateKeymOpacity($keym);
      animateKeymCounter($keym);
      animateKeymFlipElement($keym);
    } else if ($keym.hasClass('layout--ino-pt-keym-circle')) {
      animateKeymOpacity($keym);
      animateKeymCounter($keym);
      animateKeymProgressRing($keym);
    }
  }
  $(function () {
    $('.layout--keym').once('keym').each(function (index, element) {
      var callFunction = true;
      $(window).on('scroll', function (e) {
        if (callFunction && $(element).offset().top + $(element).height() < $(window).scrollTop() + $(window).height()) {
          animateKeym($(element));
          callFunction = false;
        }
      });
    });
    $(window).trigger('scroll');
  });
})(jQuery, Drupal);